/**
 * Initializes the OIDC client with the provided configuration and handles user authentication and authorization.
 * @param success - A function to be called upon successful authentication.
 * @param error - A function to be called upon authentication error.
 */
import { UserManager, WebStorageStateStore, UserManagerSettings, User } from 'oidc-client';
const authorizationDataIdTokenKey = 'authorizationDataIdToken';
const authorizationDataKey = 'authorizationData';
const tokenCeline = 'tokenCeline';

let mgr: UserManager = null;
let user: any;

declare var window: any;

function isLoggedIn(config: UserManagerSettings) {
    user = JSON.parse(sessionStorage.getItem(`oidc.user:${config.authority}:${config.client_id}`)) as User;
    return user != null && !user.expired;
}

export function initOIDC(success: Function, error: Function) {
    const returnUrl: string = (window.location.hash) ? `?ReturnUrl=${encodeURIComponent(window.location.href)}` : `?reset=${localStorage.getItem('celineResetV1')}`;
    const returnUrlWithToken: string = (window.location.hash) ? `?ReturnUrl=${encodeURIComponent(window.location.href)}` : localStorage.getItem('celineResetV1') ? `?reset=${localStorage.getItem('celineResetV1')}` : ``;
    const config = {
        client_id: JSON.parse(window['__CONFIGURATION'])['clientId'], // good
        redirect_uri: `${window.location.protocol}//${window.location.host}/auth-callback.html${returnUrl}`,
        response_type: JSON.parse(window['__CONFIGURATION'])['responseType'],
        scope: JSON.parse(window['__CONFIGURATION'])['scopes'],
        authority: JSON.parse(window['__CONFIGURATION'])['authUrl'],
        post_logout_redirect_uri: location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : ''),
        silent_redirect_uri: location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + `/silent-renew.html`,
        revokeAccessTokenOnSignout: true,
        automaticSilentRenew: true,
        accessTokenExpiringNotificationTime: 180,
        silentRequestTimeout: 60000,
        filterProtocolClaims: true,
        loadUserInfo: true,
        userStore: new WebStorageStateStore({ store: sessionStorage }),
        includeIdTokenInSilentRenew: false
    }

    // Logging, if needed
    // Oidc.Log.logger = console;
    // Oidc.Log.level = Oidc.Log.INFO;

    mgr = new UserManager(config);

    // Set to window
    window._oidc = mgr;

    mgr.events.addUserLoaded(user => {
        sessionStorage.setItem(authorizationDataIdTokenKey, user.id_token);
        sessionStorage.setItem(authorizationDataKey, user.access_token);
        localStorage.setItem(tokenCeline, user.id_token)
    });


    // On error
    mgr.events.addSilentRenewError(function (error) {
        ineum('reportEvent', '@celine: Error occurred on silent renew');
        setTimeout(() => {
            window.location = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + `/#/session-expired`
        }, 2000)
    });

    if (window.location.href.indexOf('session-expired') >= 0) {
        ineum('reportEvent', '@celine: Manual reset session');
        document.location.href = '/';
    }

    // User still logged in
    if ((isLoggedIn(config))) {

        // Only set reset if not in widget frame
        if ((window.location.href.indexOf("#/widget-frame?") === -1)) {
            localStorage.setItem('celineResetV1', 'true');
        }

        localStorage.setItem(tokenCeline, user.id_token)
        sessionStorage.setItem(authorizationDataIdTokenKey, user.id_token);
        sessionStorage.setItem(authorizationDataKey, user.access_token);
        success(true)
    }
    else {
        if ((localStorage.getItem('celineResetV1') === 'true') && (window.location.href.indexOf("#/widget-frame?") === -1)) {
            // User closed browser in logged in state, so we need to sign them out
            // We can't depend on getUser(); to return token for id_token_hint, due to previously variables
            // stored in sessionStorage
            mgr.getUser().then(() => {
                let idTokenHint = localStorage.getItem(tokenCeline) ? localStorage.getItem(tokenCeline) : '';
                localStorage.removeItem('celineResetV1');
                localStorage.removeItem('celineResetV2');
                localStorage.removeItem(tokenCeline);
                mgr.removeUser();
                mgr.signoutRedirect({ id_token_hint: idTokenHint, post_logout_redirect_uri: config.post_logout_redirect_uri })
            })
        } else {
            // User is not logged in, so we need to sign them in
            mgr.signinRedirect()
                .catch(() => {
                    ineum('reportEvent', '@celine: Failed to connect with authentication server');
                    setTimeout(() => { window.location = `${window.location.protocol}//${window.location.host}/authentication-error.html`; });
                });
        }
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/oidc-helper.ts